import siteConfig from "./siteConfig.json";

const aboutStatsConfig = siteConfig.statistics?.about ?? {};

export const aboutPageData = {
  seo: {
    title: "About Us | NextEra Abroad",
    description:
      "Discover the story, vision, and student-first values behind NextEra Abroad — premium overseas education guidance built on trust and clarity."
  },
  hero: {
    kicker: "About NextEra Abroad",
    title: "Built to Guide Global Ambitions with Clarity",
    subtitle:
      "We help students and families move from uncertainty to confident action through strategic counselling, transparent planning, and thoughtful mentorship.",
    trustTags: [
      "Student-first process",
      "Parent-reassuring communication",
      "End-to-end support"
    ],
    metrics: aboutStatsConfig.heroMetrics ?? [
      { value: "1:1", label: "Personal guidance" },
      { value: "9+", label: "Global destinations" },
      { value: "1200+", label: "Student journeys guided" }
    ],
    highlights: [
      "Profile-first counselling for smarter decisions",
      "Strategic shortlist planning with realistic pathways",
      "Structured admissions and visa documentation support"
    ]
  },
  story: {
    title: "Our Story",
    intro:
      "NextEra Abroad was created to make international education planning simpler, clearer, and more human.",
    chapters: [
      {
        title: "Why We Started",
        text: "Too many students make life-changing choices with incomplete information and unnecessary pressure. We wanted to change that."
      },
      {
        title: "What We Changed",
        text: "We designed a premium counselling experience that combines strategic admissions expertise with genuine mentorship."
      },
      {
        title: "What We Stand For",
        text: "Every recommendation should be informed, every process should be transparent, and every student should feel supported."
      }
    ]
  },
  founders: [
    {
      name: "G Sai Ram Reddy",
      title: "Founder & Strategy Mentor",
      initials: "GSR",
      bio: "Sai Ram Reddy leads strategic counselling at NextEra Abroad, helping students align destination choices, program fit, and long-term career outcomes with clarity and confidence.",
      focus: "Academic planning and university strategy"
    }
  ],
  visionMission: [
    {
      title: "Our Vision",
      text: "To become the most trusted partner for students pursuing international education with clarity, confidence, and long-term purpose."
    },
    {
      title: "Our Mission",
      text: "To provide personalized, transparent, and end-to-end guidance that helps students and families make informed global education decisions."
    }
  ],
  values: [
    "Student-first guidance",
    "Transparent communication",
    "Personalized strategy",
    "Long-term mentorship"
  ],
  supportSystem: [
    {
      role: "Counselling Support",
      text: "One-on-one profile understanding and destination clarity based on student goals."
    },
    {
      role: "Admissions Guidance",
      text: "Strategic shortlisting and application workflows built for strong outcomes."
    },
    {
      role: "Documentation Assistance",
      text: "Structured checklist support to keep every critical submission step on track."
    },
    {
      role: "Visa Support",
      text: "Practical visa process guidance with complete documentation readiness."
    },
    {
      role: "Student Success Guidance",
      text: "Continuous mentoring from planning stage to final decision confidence."
    }
  ],
  trustPoints: [
    {
      title: "Personalized Attention",
      text: "Every journey is planned around the student’s profile, priorities, and aspirations."
    },
    {
      title: "Clear and Transparent Process",
      text: "Families stay informed through realistic expectations and structured milestone tracking."
    },
    {
      title: "Strategic Decision-Making",
      text: "University choices are guided by fit, long-term value, and career relevance."
    },
    {
      title: "Support for Students and Parents",
      text: "We communicate clearly with both students and families throughout the journey."
    }
  ],
  trustSnapshot: aboutStatsConfig.trustSnapshot ?? [
    { value: "1200+", label: "Students Guided" },
    { value: "9+", label: "Years of Experience" },
    { value: "9", label: "Destination Pathways" }
  ],
  cta: {
    title: "Let’s Shape Your Global Journey with Clarity and Confidence",
    subtitle:
      "If you are ready to plan your next chapter with expert support, we are here to guide you personally.",
    primary: {
      label: "Book Free Counselling",
      to: siteConfig.links.bookCounselling
    },
    secondary: {
      label: "Contact Us",
      to: "/contact"
    }
  }
};
